<template>
  <v-container>
    <v-flex xs12 class="background">
      <v-toolbar height="56" color="primary">
        <v-toolbar-title id="idCabecalhoJanela" class="subheading white--text">
          Veículos do Endosso
        </v-toolbar-title>
      </v-toolbar>
      <v-layout pa-5>
        <v-flex row wrap>
          TIPO DE ENDOSSO
          <p>{{ getTipoEndosso(idTipoEndosso) }}</p>
        </v-flex>
        <v-flex row wrap> CÓD. COTAÇÃO ENDOSSO </v-flex>
        <v-flex> N. PROPOSTA / ENDOSSO </v-flex>
        <v-flex>DIAS DE VIGÊNCIA ENDOSSO </v-flex>
        <v-flex>RAZÃO SOCIAL </v-flex>
        <v-flex> CNPJ </v-flex>
        <v-flex> QTD. ÍTENS INCLUSÃO </v-flex>
        <v-flex> VLR.ENDOSSO </v-flex>
        <v-flex>
          <br />
        </v-flex>
        <v-spacer></v-spacer>
        <v-spacer></v-spacer>
      </v-layout>
    </v-flex>
    <v-container pa-5 class="background data-table">
      <v-card elevation="0">
        <v-card-title>
          <v-flex xs12 sm11 md6 lg4>
            <transition name="fade">
              <v-flex xs1 v-if="!filtro.pesquisa.opened">
                <v-btn
                  v-if="!filtro.pesquisa.opened"
                  @click="filtroFunctions().abrirFiltroPesquisa()"
                  color="primary"
                  round
                  outline
                  icon
                  ><v-icon>search</v-icon></v-btn
                >
              </v-flex>
              <v-flex v-else>
                <v-text-field
                  v-model="filtro.pesquisa.conteudo"
                  prepend-icon="search"
                  @click:prepend="filtroFunctions().fecharFiltroPesquisa()"
                  @blur="filtroFunctions().fecharFiltroPesquisa()"
                  label="Busca"
                  autofocus
                  clearable
                ></v-text-field>
              </v-flex>
            </transition>
          </v-flex>
          <v-spacer></v-spacer>
          <v-spacer></v-spacer>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            round
            :disabled="selected === null"
            @click="dialog = true"
            >alterar</v-btn
          >
        </v-card-title>
      </v-card>

      <template>
        <div class="table-width">
          <v-data-table
            :headers="headers"
            :items="errosFiltrados"
            :search="filtro.pesquisa.conteudo"
            :pagination.sync="pagination"
            :rows-per-page-items="[10, 25, 50, 100, 150, 200, 300, 400, 500]"
            rows-per-page-text="Itens por página"
            item-key="item"
            class="elevation-0"
          >
            <template v-slot:items="props">
              <td>
                <v-checkbox
                  class="checkbox"
                  color="primary"
                  primary
                  hide-details
                  :value="
                    props.item && selected && props.item.item === selected.item
                  "
                  @change="(value) => (selected = value ? props.item : null)"
                  :disabled="camposDisabled || (selected && selected.item !== props.item.item)"
                ></v-checkbox>
              </td>

              <td
                v-for="([texto, atributos], index) in colunas(props.item)"
                :key="index"
                v-bind="atributos"
                :class="[' themeGrey--text click', ...(atributos.class || [])]"
              >
                {{ texto }}
              </td>
            </template>
            <template v-slot:pageText="props">
              {{ props.pageStart }} - {{ props.pageStop }} de
              {{ props.itemsLength }}
            </template>
            <template v-slot:no-results>
              <v-alert :value="true" color="error" icon="warning">
                Sua pesquisa não foi encontrada.
              </v-alert>
            </template>
          </v-data-table>
        </div>
      </template>
      <v-snackbar v-model="snack" :timeout="3000" :color="snackColor">
        {{ snackText }}
        <v-btn flat @click="snack = false">Fechar</v-btn>
      </v-snackbar>
    </v-container>
    <v-layout pt-5>
      <v-flex>
        <v-btn color="primary" @click="voltar" flat> Voltar </v-btn>
      </v-flex>
      <v-spacer></v-spacer>
      <v-flex v-if="!camposDisabled" d-flex justify-center>
        <v-btn class="button-custom"  @click="abrirDialogModalEmitirEndossoAlteracao()" flat> Emitir </v-btn>
      </v-flex>
      <v-flex v-else d-flex justify-center>
        <v-btn class="button-custom" @click="fecharVoltarGrid" flat> Fechar </v-btn>
      </v-flex>
    </v-layout>



    <template>
      <v-layout row justify-center>
        <v-dialog v-model="dialog" hide-overlay fullscreen>
          <AlterarItemEndossoModal
            v-if="dialog"
            @add="adicionarModificacao($event), (dialog = false)"
            :item="proximoIndice"
            :dialog="dialog"
            @fechar="dialog = false"
            :campos="campos"
            :alterarValores="true"
            :placa="placaSelecionada"
            :chassi="chassiSelecionado"
            :chassis="chassis"
            :modificacoes="modificacoesItem()"
            diferencaObjetos
          />
        </v-dialog>
      </v-layout>
    </template>

    <template>
      <v-layout row justify-center>
        <v-dialog persistent v-model="dialogModalEmitirEndossoAlteracao" max-width="500px">
          <ModalEmitirEndossoAlteracao
            v-if="dialogModalEmitirEndossoAlteracao"
            :dialog="dialogModalEmitirEndossoAlteracao"
            :idApolice="parseInt(idApolice)"
            :idPropostaStatus="idPropostaStatus"
            @fechar="dialogModalEmitirEndossoAlteracao = false"
            @comecarLoading="loaderAtiva"
            @fecharLoading="loderFecha"
          />
        </v-dialog>
      </v-layout>
    </template>
    <template>
      <v-dialog
        persistent
        v-model="loaderPagina"
        width="500"
        content-class="elevation-0"
      >
        <v-card>
          <v-container style="background-color: #FFF;height: 100px;">
            <v-layout
              row
              wrap
              class="fill-height"
              align-content="center"
              justify="center"
            >
              <v-flex md12 class="text-subtitle-1 text-center">
                <p
                  style="font-weight: bold; margin-bottom: 0; text-align: center"
                >
                  Processando, aguarde...
                </p>
              </v-flex>
              <v-flex md12>
                <v-progress-linear
                  :indeterminate="true"
                  color="primary"
                  height="6"
                  value="15"
                ></v-progress-linear>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card>
      </v-dialog>
    </template>
    <template>
      <v-dialog persistent v-model="mostrarModalErroChassiDuplicado" max-width="570px">
        <ModalErroChassiExistente
          :mensagemErro = "mensagensErroChassiDuplicado"
          :textoSalvarOuEmitir = "'EMITIR'"
          :mostrarBotaoSalvarOuEmitir = "true"
          @fecharModalErroChassiExistente="
            mostrarModalErroChassiDuplicado = false;
            $emit('fecharModalErroChassiExistente');
          "
          @emitirOuSalvarPropostaComErros="
            emitirAlteracao()
            mostrarModalErroChassiDuplicado = false;
            $emit('emitirOuSalvarPropostaComErros');
          ">
        </ModalErroChassiExistente>
      </v-dialog>
    </template>
  </v-container>
</template>

<script>
import axios from "axios";
import { mapState } from "vuex";
import usuarioHelper from "@/helpers/usuario-logado.js";
import { adicionarId } from "@/helpers/url-helper.js";
import AlterarItemEndossoModal from "./AlterarItemEndossoModal";
import ModalEmitirEndossoAlteracao from "./ModalEmitirEndossoAlteracao";
import ModalErroChassiExistente from "../frota/ModalErroChassiExistente";
import statusEndossoEnum from "@/helpers/status-endosso-enum.js";

export default {
  name: "GridEndossoVeiculosAlteracao",
  components: {
    AlterarItemEndossoModal,
    ModalEmitirEndossoAlteracao,
    ModalErroChassiExistente,
  },
  data() {
    return {
      loaderPagina: false,
      idPropostaStatus: null,
      idApolice: null,
      snackbar: {
        visivel: false,
        sucesso: false,
        mensagem: "",
      },
      conteudoPlanilha: null,
      dialogModalEmitirEndossoAlteracao: false,
      itemRemovidoList: [],
      dialogProgress: false,
      idTipoEndosso: null,
      arquivoFaltante: [],
      arquivoValido: true,
      numeroRevisao:null,
      arquivo: {},
      loading: false,
      filtrarErros: false,
      idStatusEndosso:null,
      snack: false,
      snackColor: "",
      snackText: "",
      dialog: false,
      dialogAvaliando: false,
      pagination: {
        sortBy: "name",
      },
      selected: null,
      regras: {
        notNull: [(v) => !!v || "Você não pode deixar este campo em branco"],
      },
      filtro: {
        pesquisa: {
          opened: false,
          conteudo: "",
        },
      },
      campos: {
        numeroRevisao: null,
        erroPlanilha2: null,
        listaEstados: [],
        tipoVeiculoList: [],
        catVeiculoList: [],
        ufPernoiteList: [],
        usoDoVeiculoList: [],
        propriedadeRegistroDoCrlvList: [],
        diasGarantZeroKmList: [],
        tipoCoberturaList: [],
        tipoDeContratacaoList: [],
        tipoDeFranquiaList: [],
        tipoDePropostaList: [],
        ciaRenovacaoList: [],
        kmAssistenciaList: [],
        carroReservaList: [],
        descrCarroceriaList: [],
        descrEquipamentosList: [],
        descrAcessoriosList: [],
        coberturaVidrosList: [],
        codigoSistemaRastreamentoList: [],

        classeList: new Array(11).fill({}).map((_, index) => ({
          id: index,
          titulo: `${index}`,
        })),
        renovacaoSinistroOptions: [
          {
            id: true,
            titulo: "Com sinistro",
          },
          {
            id: false,
            titulo: "Sem Sinistro",
          },
        ],
      },
      resultados: {
        totalPremio: null,
      },
      headers: [
        { text: "", value: "", notSortable: false, class: "pa-0" },
        { text: "ITEM", align: "center", value: "item" },
        {
          text: "PLACA",
          align: "center",
          value: "placa",
        },
        { text: "CHASSI", align: "center", value: "chassi" },
        { text: "FIPE", align: "center", value: "fipe", style: "width: 100px" },
        { text: "MARCA", align: "center", value: "marca" },
        { text: "MODELO ", align: "center", value: "modelo" },
        { text: "TIPO VEÍCULO", align: "center", value: "tipoVeiculo" },
        { text: "CAT. VEÍCULO", align: "center", value: "catVeiculo" },
        { text: "ANO FAB.", value: "anoFab" },
        { text: "ANO MOD.",align: "center", value:"anoMod" },
        { text: "UF PERNOITE",align: "center", value:"ufPernoite" },
        { text: "USO DO VEÍCULO", align: "center", value:"usoDoVeiculo" },
        {
          text: "PROPRIEDADE (REGISTRO DO CRLV)",
           align: "center",  value:"propriedadeRegistroDoCrlv",
        },
        { text: "PROPRIETÁRIO",  align: "center", value:"proprietario" },
        { text: "CPF/CNPJ",  align: "center", value:"cpfCnpj" },
        { text: "NOME SOCIAL",  align: "center", value:"nomeSocial" },
        { text: "CHASSI REMARCADO",  align: "center", value:"chassiRemarcado" },
        { text: "ZERO KM",  align: "center", value:"zeroKm" },
        { text: "SAÍDA CONCESSIONÁRIA",  align: "center", value:"saidaDaConcessionaria" },
        { text: "QUANT PASSAGEIROS",  align: "center", value:"quantPassageiro" },
        { text: "DISPOSITIVO DE SEGURANÇA",  align: "center", value:"codigoSistemaRastreamento"},
      ],
      dadosPlanilha: [],
      chassis: [],
      chassiQtdPassageiros: [],
      mensagensErroChassiDuplicado: null,
      mostrarModalErroChassiDuplicado: false,
    };
  },

  computed: {
    ...mapState("formEndosso", [
      "id",
      "proponenteCnpj",
      "proponenteRazaoSocial",
    ]),

    camposDisabled() {
      return (
        (this.idStatusEndosso > statusEndossoEnum.statusEndosso.SALVO &&
          this.idStatusEndosso != statusEndossoEnum.statusEndosso.PENDENTE) ||
        this.idPropostaStatus == 7 ||
        this.idPropostaStatus == 12
      );
    },

    quantidadeItens() {
      return this.$store.getters["formEndosso/quantidadeItem"];
    },

    mostrarBotaoReavaliar() {
      if (this.selected) {
        return false;
      }
      return !!this.erroPlanilha[this.selected.item];
    },

    errosFiltrados() {
      return this.filtrarErros && this.numeroErros
        ? this.dadosPlanilha.filter((value) => value.erro)
        : this.dadosPlanilha;
    },

    numeroErros() {
      return Object.values(this.erroPlanilha).reduce(
        (acc, cur) => (cur ? acc + 1 : acc),
        0
      );
    },

    erroPlanilha() {
      return this.formatarErro(this.dadosPlanilha);
    },

    proximoIndice() {
      return (
        this.dadosPlanilha.reduce(
          (acc, cur) => (cur.item > acc ? cur.item : acc),
          -1
        ) + 1
      );
    },

    placaSelecionada() {
      return this.selected ? this.selected.placa : null;
    },

    chassiSelecionado() {
      return this.selected ? this.selected.chassi : null;
    },

    objetoModificado(){
      let itensModificado = this.$store.getters["formEndosso/requisicaoEndossoModificar"]
      if(itensModificado.idTipoEndosso === 6) {
        let listaVeiculosModificados = itensModificado.itemModificadoList

        let itensModificadoCopia = Object.assign({}, itensModificado)
        let listaVeiculosModificadosCopia = listaVeiculosModificados.map(it => Object.assign({}, it))
        itensModificadoCopia.itemModificadoList = listaVeiculosModificadosCopia
        for(var veiculoModificado of listaVeiculosModificadosCopia){
          var propriedades = Object.keys(veiculoModificado)
          for(var propriedade of propriedades){
            var value = veiculoModificado[propriedade]
            if(value !=null && value !=undefined && value.id === 0){
              veiculoModificado[propriedade] = null
            }
          }
        }
        return itensModificadoCopia.length > 0;
      }
    },
  },

  mounted() {
    this.idTipoEndosso = parseInt(this.$route.query.idTipoEndosso);
    this.idApolice = this.$route.query.id ? this.$route.query.id : 0;
    this.idRascunhoEndosso = this.$route.query.idRascunhoEndosso;
    this.numeroRevisao = this.$route.query.numeroRevisao;
    this.idPropostaStatus = this.$route.query.idPropostaStatus
      ? this.$route.query.idPropostaStatus
      : null;
    this.idStatusEndosso = this.$route.query.idStatusEndosso ? this.$route.query.idStatusEndosso : null;

    this.dadosPlanilha =
      this.$store.getters["formEndosso/cloneConteudoPlanilha"];
    if(this.numeroRevisao) {
      this.buscarStatus();
    }
    this.buscaOpcoes();
    if (this.$route.query.idRascunhoEndosso == undefined) {
      return this.buscarEndosso();
    }
  },

  methods: {
    loaderAtiva() {
      this.loaderPagina = true;
    },

    loderFecha() {
      this.loaderPagina = false;
    },

    fecharVoltarGrid() {
      this.$router.push("/GridPrincipal/InfoGerais/GridEndossos?id=" + this.idApolice);
    },

    async buscarNumPassageiro(chassis){
      const chassiModel = {
        chassis: chassis
      }
      var response = await axios.post(
        `${process.env.ENDOSSORMS}/v1/buscarNumeroPassageiro/`,chassiModel,
        {
          headers: {
            Authorization: `Bearer ${usuarioHelper.USUARIO_LOGADO().token}`
          }
        }
      );
      this.chassiQtdPassageiros = response.data
    },

    buscarEndosso() {
      this.$store.commit("startLoading");
      axios
        .get(
          `${process.env.URL_APOLICEMS}/v1/visualizarApolice/` +
            this.idApolice +
            `/?page=${(this.pagination.page || 1) - 1}&size=${this.pagination.rowsPerPage || 10}`,
          {
            headers: {
              Authorization: `Bearer ${usuarioHelper.USUARIO_LOGADO().token}`,
            },
          }
        )
        .then((response) => {
          this.dadosPlanilha = response.data.itemCotacaoList;
          this.aplicarModificacoes();
          this.$store.commit("endLoading");
        })
        .catch((err) => {
          this.$store.commit("endLoading");
        });
    },

    buscarStatus() {
      this.$store.commit("startLoading");
      axios
        .get(
          `${process.env.URL_ENDOSSOMS}/v1/retornaStatusEndosso/` +
            this.numeroRevisao,
          {
            headers: {
              Authorization: `Bearer ${usuarioHelper.USUARIO_LOGADO().token}`,
            },
          }
        )
        .then((response) => {
          this.idStatusEndosso = response.data;
        })

      this.$store.commit("endLoading");
    },

    colunas(item) {
      const valor = (key) => {
        if (item.modificacoes) {
          if (item.modificacoes.hasOwnProperty(key)) {
            return item.modificacoes[key]
          }
        }
        return item[key]
      }
      return [
        [this.formatarNumeroItem(valor("item")), { class: "pa-4 text-align-center" }],
        [valor("placa"), { class: "text-align-center"}],
        [valor("chassi") || '-',{ class: "pa-4 text-align-center" }],
        [valor("fipe") || '-',{ class: "pa-4 text-align-center" }],
        [valor("marca") || '-',{ class: "pa-4 text-align-center" }],
        [valor("modelo") || '-',{ class: "text-align-center"}],
        [this.traduzValorObjeto(valor("tipoVeiculo")), { class: "text-align-center"}],
        [this.traduzValorObjeto(valor("catVeiculo")), { class: "text-align-center"}],
        [valor("anoFab") || '-',{ class: "text-align-center"}],
        [valor("anoMod") || '-',{ class: "text-align-center"}],
        [this.traduzValorObjeto(valor("ufPernoite")), { class: "text-align-center"}],
        [this.traduzValorObjeto(valor("usoDoVeiculo")), { class: "text-align-center"}],
        [this.traduzValorObjeto(valor("propriedadeRegistroDoCrlv")), { class: "text-align-center"}],
        [valor("proprietario") || '-',{ class: "text-align-center"}],
        [valor("cpfCnpj") || '-',{ class: "text-align-center"}],
        [valor("nomeSocial") || '-',{ class: "text-align-center"}],
        [this.traduzValor(valor("chassiRemarcado")), { class: "text-align-center"}],
        [this.traduzValor(valor("zeroKm")), { class: "text-align-center"}],
        [valor("saidaDaConcessionaria") || '-',{ class: "text-align-center"}],
        [this.buscarQuantPassageiro(item.chassi) !== undefined ? this.buscarQuantPassageiro(item.chassi):valor("quantPassageiro") || '-',{ class: "text-align-center"}],
        [this.traduzValorObjeto(valor("codigoSistemaRastreamento")), { class: "text-align-center"}],
      ];
    },

    buscarQuantPassageiro(chassi){
      for(var quant of this.chassiQtdPassageiros){
        if(quant.nrChassi === chassi){
          return quant.nrQtdPax
        }
      }
    },

    modificacoesItem() {
      return this.selected && this.selected.modificacoes
        ? this.selected.modificacoes
        : null;
    },

    submeterArquivo() {
      this.loading = true;
      const formData = new FormData();
      formData.append("planilha", this.arquivo);
      axios
        .post(`${process.env.URL_PLANILHAMS}/v1/validarPlanilha`, formData, {
          headers: {
            Authorization: `Bearer ${usuarioHelper.USUARIO_LOGADO().token}`,
          },
        })
        .then((response) => {
          this.arquivoValido =
            typeof response.data.valido === "boolean"
              ? response.data.valido
              : true;
          this.arquivoFaltante =
            response.data.naoEncontrados instanceof Array
              ? response.data.naoEncontrados
              : [];
          this.conteudoPlanilha =
            response.data.conteudo instanceof Array
              ? response.data.conteudo
              : [];
          this.erroPlanilha2 =
            response.data.erros instanceof Array ? response.data.erros : [];
          if (this.arquivoValido) {
            this.avaliarPlanilha();
          }
        })
        .catch((err) => {
          this.arquivoValido = false;
        })
        .finally(() => {
          this.loading = false;
        });
    },

    atualizarGrid() {
      this.$store.commit("formEndosso/setConteudoPlanilha", {
        dados: this.conteudoPlanilha.map((e) => {
          const item = this.erroPlanilha2.find((v) => v.item === e.item);
          return { ...e, erro: item && item.erro };
        }),
      });
      this.$store.commit("formEndosso/setErroPlanilha", {
        dados: this.erroPlanilha2,
      });
    },

    formatarErro(novosErros, listaErros = {}) {
      return {
        ...listaErros,
        ...novosErros.reduce(
          (acc, cur) => ({ ...acc, [cur.item]: cur.erro }),
          {}
        ),
      };
    },

    formatarCnpj(cnpj) {
      if (typeof cnpj === "string" && cnpj.match(/^[A-Za-z0-9]{12}\d{2}$/)) {
        return cnpj.replace(
          /^(.{2})(.{3})(.{3})(.{4})(.{2})$/,
          "$1.$2.$3/$4-$5"
        );
      }
      return "";
    },

    formatarData(data) {
      if (data) {
        return new Date(data).toLocaleDateString("pt-BR", {
          timeZone: "UTC",
          year: "numeric",
          month: "numeric",
          day: "numeric",
        });
      }
    },

    encontrarChassiCorrespondente(listaPrincipal, listaModificacoes) {
      const resultados = [];

      listaPrincipal.forEach(itemAtual => {
        const itemEncontrado = listaModificacoes.find(itemModificacao => itemModificacao.item === itemAtual.item);
        if (itemEncontrado) {
          resultados.push({
            chassi: itemEncontrado.chassi
              ? itemEncontrado.chassi
              : itemAtual.chassi
          });
        }
      });

      return resultados;
    },

    buscarListaVeiculosAlterados() {
      let listaModificacoes = this.dadosPlanilha
          .filter((e) => e.modificacoes)
          .map((e) => e.modificacoes)
      return this.encontrarChassiCorrespondente(this.dadosPlanilha, listaModificacoes)
    },

    abrirDialogModalEmitirEndossoAlteracao() {
      let listaVeiculosAlterados = this.buscarListaVeiculosAlterados();
      this.verificarSeExisteChassiDuplicado(listaVeiculosAlterados);
    },

    verificarSeExisteChassiDuplicado(jsonListaVeiculos) {
      const formData = new FormData();
      formData.append("jsonListaVeiculos", JSON.stringify(jsonListaVeiculos));
      formData.append("idApolice", this.idApolice)

      axios
        .post(`${process.env.URL_PLANILHAMS}/v1/encontrarErrosListaVeiculos`, formData, {
          headers: {
            Authorization: `Bearer ${usuarioHelper.USUARIO_LOGADO().token}`
          }
        })
        .then((response) => {
          this.emitirAlteracao()
        })
        .catch(error => {
          this.mensagensErroChassiDuplicado = error.response.data.message;
          this.mostrarModalErroChassiDuplicado = true;

          this.loaderPagina = false;
        });
    },

    emitirAlteracao() {
      this.$store.commit("formEndosso/setItensModificados", {
        dados: this.dadosPlanilha
          .filter((e) => e.modificacoes)
          .map((e) => e.modificacoes),
      });

      this.$store.commit("formEndosso/setItensAdicionados", {
        dados: [],
      });

      this.dialogModalEmitirEndossoAlteracao = true;
    },

    formatarNumeroItem(item) {
      const numero = `000${item}`;
      return numero.slice(numero.length - 3);
    },

    getTipoEndosso(idTipoEndosso) {
      if (idTipoEndosso == 1) return "COBRANÇA";
      else if (idTipoEndosso == 2) return "RESTITUIÇÃO";
      else if (idTipoEndosso == 3) return "SEM MOVIMENTAÇÃO";
      else if (idTipoEndosso == 4) return " CANCELAMENTO";
      else if (idTipoEndosso == 5) return " SUBSTITUIÇÃO";
      else if (idTipoEndosso == 6) return " ALTERAÇÃO";
    },

    buscarTitulo(entity, list) {
      if (entity) {
        const campo = list.find(
          (item) => item === entity.id || item.id === entity.id
        );
        if (campo) {
          return campo.titulo;
        }
      }
      return "-";
    },

    aplicarModificacoes() {
      const modificados = this.$store.state.formEndosso.itemModificadoList;
      modificados.forEach((e) => this.adicionarModificacao(e));
        for(var chassi of this.dadosPlanilha){
          this.chassis.push(chassi.chassi)
        }
      this.buscarNumPassageiro(this.chassis)
    },

    changeSort(column) {
      if (this.pagination.sortBy === column) {
        this.pagination.descending = !this.pagination.descending;
      } else {
        this.pagination.sortBy = column;
        this.pagination.descending = false;
      }
    },

    save() {
      this.snack = true;
      this.snackColor = "success";
      this.snackText = "Item salvo";
    },

    saveErro(item) {
      this.save();
      item.erro = true;
    },

    adicionarModificacao(itemModificado) {
      if (itemModificado) {
        const buscaEditado = this.dadosPlanilha.find(
          (e) => itemModificado.item === e.item
        );
        if (buscaEditado) {
          buscaEditado.modificacoes = itemModificado;
        }
      }
    },

    filtroFunctions: function () {
      const self = this;
      return {
        abrirFiltroPesquisa: function () {
          self.filtro.pesquisa.opened = true;
        },
        fecharFiltroPesquisa: function () {
          if (
            !self.filtro.pesquisa.conteudo ||
            self.filtro.pesquisa.conteudo == ""
          ) {
            self.filtro.pesquisa.opened = false;
          }
        },
      };
    },

    buscaOpcoes() {
      axios
        .get(`${process.env.URL_PLANILHAMS}/v1/buscarOpcoesCampos/`, {
          headers: {
            Authorization: `Bearer ${usuarioHelper.USUARIO_LOGADO().token}`,
          },
        })
        .then((response) => {
          [
            "tipoVeiculoList",
            "catVeiculoList",
            "ufPernoiteList",
            "usoDoVeiculoList",
            "propriedadeRegistroDoCrlvList",
            "diasGarantZeroKmList",
            "tipoCoberturaList",
            "tipoDeContratacaoList",
            "tipoDeFranquiaList",
            "tipoDePropostaList",
            "ciaRenovacaoList",
            "kmAssistenciaList",
            "carroReservaList",
            "descrCarroceriaList",
            "descrEquipamentosList",
            "descrAcessoriosList",
            "coberturaVidrosList",
            "codigoSistemaRastreamentoList",

          ].forEach((nome) => {
            this.campos[nome] =
              response.data[nome] instanceof Array ? response.data[nome] : [];
              if(nome === 'ciaRenovacaoList' || nome === 'carroReservaList'
                || nome === 'descrCarroceriaList' || nome === 'descrEquipamentosList' || nome === 'descrAcessoriosList'
               || nome === 'coberturaVidrosList'){
                response.data[nome].push({id:0,titulo:'Nenhum'});
              }
          });
        })
        .catch((err) => {
          console.error(err);
        });
    },

    traduzValor(value) {
      if (value === true) {
        return (value = "Sim");
      } else {
        return (value = "Não");
      }
    },

    traduzValorObjeto(value) {
      if (value) {
        return value.titulo;
      } else {
        return '-';
      }
    },

    validaColunas() {
      return Object.values(this.erros).every((item) =>
        Object.values(item).every((subItem) => subItem.erro !== true)
      );
    },

    voltar: function () {
      if (this.numeroRevisao) {
        this.$router.push(
          `/GridPrincipal/InfoEndosso?id=${this.idApolice}&idTipoEndosso=${this.idTipoEndosso}&numeroRevisao=${this.numeroRevisao}&idPropostaStatus=${this.idPropostaStatus}`
        );
      } else if (this.idRascunhoEndosso) {
        this.$router.push(
          `/GridPrincipal/InfoEndosso?id=${this.idApolice}&idTipoEndosso=${this.idTipoEndosso}&idRascunhoEndosso=${this.idRascunhoEndosso}&idPropostaStatus=${this.idPropostaStatus}`
        );
      } else {
        this.$router.push(
          `/GridPrincipal/InfoEndosso?id=${this.idApolice}&idTipoEndosso=${this.idTipoEndosso}&idPropostaStatus=${this.idPropostaStatus}`
        );
      }
    },

    proximo() {

      if (!this.numeroRevisao) {
        this.$router.push(
          `/GridPrincipal/CoberturaEndossoSubstituicao?id=${this.idApolice}${
            this.idStatusEndosso ? `&idStatusEndosso=${this.idStatusEndosso}` : ''
          }&idTipoEndosso=${this.idTipoEndosso}&numeroRevisao=${this.numeroRevisao}&idPropostaStatus=${this.idPropostaStatus}`
        );
      } else if (this.idRascunhoEndosso) {
        this.$router.push(
          `/GridPrincipal/CoberturaEndossoSubstituicao?id=${this.idApolice}${
            this.idStatusEndosso ? `&idStatusEndosso=${this.idStatusEndosso}` : ''
          }&idTipoEndosso=${this.idTipoEndosso}&idRascunhoEndosso=${this.idRascunhoEndosso}&idPropostaStatus=${this.idPropostaStatus}`
        );
      } else {
        if (this.idTipoEndosso === 5) {
          this.$router.push(
            `/GridPrincipal/CoberturaEndossoSubstituicao?id=${this.idApolice}${
              this.idStatusEndosso ? `&idStatusEndosso=${this.idStatusEndosso}` : ''
            }&idTipoEndosso=${this.idTipoEndosso}&idPropostaStatus=${this.idPropostaStatus}`
          );
        } else {
          this.$router.push(
            `/GridPrincipal/CoberturaEndossoSubstituicao?id=${this.idApolice}${
              this.idStatusEndosso ? `&idStatusEndosso=${this.idStatusEndosso}` : ''
            }&idTipoEndosso=${this.idTipoEndosso}&idPropostaStatus=${this.idPropostaStatus}`
          );
        }
      }
    },

    comparador(itemLista, item) {
      if (item && item.id) {
        return item.id === itemLista.id;
      }
      return false;
    },

    formatarNumeroCotacao(item) {
      const numero = `000000${item}`;
      return numero.slice(numero.length - 6);
    },
  },
};
</script>

<style>
  .background {
    background-color: white;
  }

  .table-width > div > div > table {
    width: 3000px;
  }

  .item-color > div > a {
    color: #757575 !important;
  }

  .activeError {
    border: 1px solid red;
    color: red !important;
  }

  .button-permanecer {
    background: #00456e;
    color: white !important;
  }

  .text-permanecer {
    font-weight: bold;
    color: #757575 !important;
  }
  .errorTaxa {
    color: red !important;
    font-weight: bold;
  }

  .table-grid thead {
    background-color: #00456e;
  }
  .table-grid .column {
    color: #fff !important;
  }

  .table-grid th i {
    color: #fff !important;
  }

  .dialog {
    background: #eaeaea !important;
  }

  .headline {
    color: #fff;
    font-size: 14px !important;
  }

  .text-error {
    color: #f45353;
    font-weight: bold;
  }

  .name-arquivo {
    width: 90%;
    overflow: hidden;
    text-overflow: ellipsis;
    padding: 10px 10px;
    background-color: #fff;
    border-radius: 2px;
  }

  input[type="file"] {
    display: none;
  }

  .button-custom {
    width: 100%;
    max-width: 121px;
    text-align: center;
    color: #fff !important;
    background-color: #00456e;
    border-radius: 2px;
    display: inline-block;
    padding: 9px 12px;
    cursor: pointer;

    font-weight: bold;
  }
  .button-customizado {
    text-align: center;
    color: #fff !important;
    background-color: #00456e;
    border-radius: 3px;
    display: inline-block;
    padding: 9px 12px;
    cursor: pointer;

    font-weight: bold;
  }

  .button-custom:hover {
    background-color: #063f57;
  }

  .disabled,
  .v-btn.button-custom:disabled {
    cursor: default;
    background-color: #063f57;
    color: #aaaaaa !important;
  }

  .disabled:hover {
    background-color: #063f57;
  }

  .click {
    cursor: pointer;
  }

  .size {
    size: 1;
  }

  .text-align-center {
    text-align: center;
  }
</style>



// WEBPACK FOOTER //
// src/components/pages/frota/GridEndossoVeiculosAlteracao.vue